import hotelConfig from '../config/hotel';
import type { BannerSlot } from '../types';

interface Params {
    isCashbackEnabled: boolean;
}

function getHotelBannerSlots({ isCashbackEnabled }: Params): BannerSlot[] {
    return hotelConfig
        .filter(({ id }) => {
            if (id === 'cashback') return isCashbackEnabled;
            return true;
        })
        .map(({ id, cardIndex }) => ({ bannerId: id, cardIndex }));
}

export default getHotelBannerSlots;
